import { render } from "./IconTooltip.vue?vue&type=template&id=5f46b154&scoped=true&ts=true"
import script from "./IconTooltip.vue?vue&type=script&lang=ts"
export * from "./IconTooltip.vue?vue&type=script&lang=ts"

import "./IconTooltip.vue?vue&type=style&index=0&id=5f46b154&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f46b154"]])

export default __exports__